import { DocumentNode, gql, useMutation } from '@apollo/client';

export const GENERATE_LOSS_RUN_REPORTS = gql`
  mutation generateLossRunReports(
    $entityUuid: String!
    $reportType: LossRunType!
  ) {
    generateLossRunReports(entityUuid: $entityUuid, reportType: $reportType) {
      folder
      result
      savedDocuments
    }
  }
`;

export function useGenerateLossRunReportsMutation(options = {}) {
  const { ...mutationOptions } = options;
  const [generateLossRunReports, { loading, error, reset, data }] = useMutation(
    GENERATE_LOSS_RUN_REPORTS as DocumentNode,
    {
      ...mutationOptions,
    }
  );

  return {
    generateLossRunReports,
    loading,
    error,
    reset,
    data,
  };
}
